import script from "./DashboardOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardOverview.vue?vue&type=script&setup=true&lang=js"

import "./DashboardOverview.vue?vue&type=style&index=0&id=1b61cca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b61cca2"]])

export default __exports__